import UpslidingText from "components/Upsliding-Text";
import React from "react";
import { useNavigate } from "react-router-dom";

const AboutSection = () => {
  const navigate = useNavigate();
  return (
    <div className='mt-32 md:mt-72 text-center '>
      <div className='w-fitcontent text-left mx-auto'>
        <p className='text-base md:text-3xl lg:text-5xl font-normal text-dark1 dark:text-light1 font-secondary mb-6 md:mb-12 '>
          Hi, my name is Momin Naveed,
        </p>
        <p className='text-base md:text-3xl lg:text-5xl font-normal text-dark1 dark:text-light1 font-secondary mb-6 md:mb-12 '>
          and I'm working as a Fullstack Developer for years.
        </p>
        <p className='text-base md:text-3xl lg:text-5xl font-normal text-dark1 dark:text-light1 font-secondary mb-6 md:mb-12 '>
          Let me take you through my profile.
        </p>
        <p className='text-base md:text-3xl lg:text-5xl font-normal text-dark1 dark:text-light1 font-secondary mb-6 md:mb-12 '>
          Welcome to the website!
        </p>

        <UpslidingText
          text='About me'
          color={"text-dark dark:text-light"}
          onClick={(e) => {
            window.scrollTo(0, 0);
            navigate("/about");
          }}
        />
      </div>
    </div>
  );
};

export default AboutSection;
